export enum DocumentFileType {
  PDF = 'pdf',
  CSV = 'csv',
  PNG = 'png',
  JPG = 'jpg',
  JPEG = 'jpeg',
  TIFF = 'tiff',
  XLS = 'xls',
  XLSX = 'xlsx',
  XML = 'xml',
  ZIP = 'zip',
  RAR = 'rar',
  HTML = 'html',
  MDB = 'mdb',
  DB = 'db',
  MDF = 'mdf',
}

export const documentFileTypeI18n: Record<DocumentFileType, string> = {
  [DocumentFileType.PDF]: 'Файл Adobe Acrobat',
  [DocumentFileType.CSV]: 'Файл "CSV"',
  [DocumentFileType.PNG]: 'Файл "PNG"',
  [DocumentFileType.JPG]: 'Файл "JPG"',
  [DocumentFileType.JPEG]: 'Файл "JPEG"',
  [DocumentFileType.TIFF]: 'Файл "TIFF"',
  [DocumentFileType.XLS]: 'Файл Microsoft Excel',
  [DocumentFileType.XLSX]: 'Файл Microsoft Excel',
  [DocumentFileType.XML]: 'Файл "XML"',
  [DocumentFileType.ZIP]: 'Файл Zip архива',
  [DocumentFileType.RAR]: 'Файл WinRar архива',
  [DocumentFileType.HTML]: 'Файл "HTML"',
  [DocumentFileType.MDB]: 'Файл Microsoft Access',
  [DocumentFileType.DB]: 'Файл базы данных',
  [DocumentFileType.MDF]: 'Файл образа диска',
};
